import { Address } from "./Address";
import {Person} from "./AppEntryData/Person";
import {Company} from './Company';

export class Beneficiary {
    beneficiaryId: string;
    beneficiaryRelationship: string;
    beneficiaryType: number;
    beneficiaryTypeDescription: string;
  //  company: Company;
    isPrimary: boolean;
   // name: string;
    relationship: string;
  //  address: string;
    percentage: string;
  //  emailAddress: string;
    phoneNumber: string;
    relationshipToInsured: string;
   // person: Person;
    
    //Added 
    address: Address;
    personFirst: string;
    personMiddle: string;
    personLast: string;
    personPrefix: string;
    personSuffix : string;
    personDOB : string;
    govId : string;
    companyName : string;
    trustName : string;
    trustDate : string;

    constructor() {
        this.beneficiaryId = '';
        this.beneficiaryRelationship = '';
        this.beneficiaryType = 0;
        this.beneficiaryTypeDescription = '';
        this.isPrimary = true;
       // this.name = '';
        this.relationship = '';
      // this.address = '';
        this.percentage = '';
      //  this.emailAddress = '';
        this.phoneNumber = '';
        this.relationshipToInsured = '';
     //   this.person = new Person();
      //  this.company = new Company();
        this.address = new Address();
        this.personFirst= '';
        this.personMiddle= '';
        this.personLast= '';
        this.personPrefix= '';
        this.personSuffix = '';
        this.companyName = '';
        this.trustName= '';
        this.trustDate= '';
        this.govId = '';
        this.personDOB = '';
    }
}
